/**************************************************
 * Nombre:       PaginaMantenimiento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import logo from '../Recursos/logo_redondo.svg'

const PaginaMantenimiento = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#000',
                color: '#fff',
                minHeight: '100vh',
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 18}}>
                    <img src={logo} width={'20%'} height={'auto'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                    <Typography sx={{fontSize: 24, textAlign: 'center'}}>Pagina en Mantenimiento</Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default PaginaMantenimiento